import { Status } from '../evaluation-criteria/evaluation-criteria.component'
import { Quiz } from '../quiz/pages/new-quiz/new-quiz.component'

export enum CourseStatus {
  Draft = 'Draft',
  Live = 'Live',
  PendingApproval = 'PendingApproval',
  Approved = 'Approved',
  Archive = 'Archive',
  Inactive = 'Inactive'
}
export enum ProgressBehavior {
  Limited,
  UnLimited,
  Strict
}

export enum PublishStatus {
  Draft,
  PendingApproval,
  Approved,
  Live
}

export interface Category {
  id?: string
  name: string
  status: Status
  url: string
}

export interface SubCategory {
  id?: string
  name: string
  status: Status
  url: string
  Category: Category | string
  parentid: string
}

export interface Course {
  id?: string
  name: string
  description: string
  mediaId?: string
  media?: Media
  startDate?: Date
  endDate?: Date
  isMandatory: boolean
  mandatoryReason?: string
  status: CourseStatus
  enrolledUsers?: User[]
  coaches?: User[]
  batches?: Batch[]
  categoryId?: string
  category?: Category
  tags?: string[]
  feedback?: Feedback[]
  courseModules?: CourseModule[]
  userProgress?: UserProgress[]
  createdAt?: Date
  modifiedAt?: Date
  prerequisites?: Course[]
  prerequisiteFor?: Course[]
  submissions?: Submission[]
  languageMasterId?: string
  templateId?: string
  languageMaster?: LanguageMaster
  lockDetails?: LockDetails
  CourseModule?: CourseModule[]
  learningPathEntries?: { id: string }[]
  isProcessing?: boolean
}

export interface LockDetails {
  id?: string
  status?: boolean
  timings?: Date
  userId?: string
  username?: string
}

export interface Batch {
  id: string
  name: string
  description: string
  startDate?: Date
  endDate?: Date
  status: number
  createdAt: Date
  modifiedAt: Date
  users?: User[]
  courses?: Course[]
}

export interface Media {
  id: string
  url: string
}

export interface User {
  id: string
  name: string
}

export interface Feedback {
  rating: number
}

export interface Submission {
  id: string
  content: string
}

export interface LanguageMaster {
  id: string
  name: string
}

export interface CourseModule {
  id: string
  title: string
  description?: string
  sequence: number
  status: Status
  courseLessons?: CourseLesson[]
  createdAt: Date
  modifiedAt: Date
  courseId?: string
  course?: Course
  userProgress?: UserProgress[]
  prerequisites?: string[]
  prerequisiteFor?: string[]
  submissions?: Submission[]
}

export interface CourseLesson {
  id: string
  title: string
  sequence: number
  status: Status
  pages?: Page[]
  completionInstructions?: string
  courseModuleId: string
  courseModule?: CourseModule
  userProgress?: UserProgress[]
  createdAt: Date
  modifiedAt: Date
  prerequisites?: string[]
  prerequisiteFor?: string[]
  submissions?: Submission[]
}

export enum PageType {
  Content = 'Content',
  Media = 'Media',
  Quiz = 'Quiz',
  Scorm = 'Scorm'
}

export enum QuizStatus {
  NotStarted,
  Ended
}

export interface Page {
  id: string
  title?: string
  sequence: number
  type: PageType
  courseLessonId: string
  courseLesson?: CourseLesson
  userProgress?: UserProgress[]
  quiz?: Quiz
  quizId?: string
  content?: string
  mediaId?: string
  media?: Media
  createdAt: Date
  modifiedAt: Date
  submissions?: Submission[]
}

export interface UserProgress {
  id: string
  userId: string
  memberId: string
  courseId?: string
  moduleId?: string
  lessonId?: string
  pageId: string
  pageType: PageType
  completionStatus: CompletionStatus
  createdAt: Date
  modifiedAt: Date
  course?: Course
  module?: CourseModule
  lesson?: CourseLesson
  page?: Page
}

export enum CompletionStatus {
  Pending,
  InProgress,
  Failed,
  Completed
}
